module.exports = __webpack_public_path__ + "img/Comic05-4.6aa5a06c.png";